import { EmptyValue } from "@/components/ui/empty-value";

interface RelocationOrderDetailInfoRowProps {
  label: string;
  value?: string | null;
  mono?: boolean;
}

export function RelocationOrderDetailInfoRow({ label, value, mono = false }: RelocationOrderDetailInfoRowProps) {
  return (
    <div>
      <div className="text-muted-foreground text-xs font-medium">{label}</div>
      <div className={mono ? "font-mono text-sm" : "text-sm"}>{value || <EmptyValue />}</div>
    </div>
  );
}
